import React, {Component} from "react"
import {Container, Header} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization, interpolateString, parseMultilineString} from "../utils/localization";
import {setPrevRoute} from "../actions/appHeaderActions";
import Footer from "./footer";
import {checkIsVerified, EDUCATIONAL_AUTO_ADVANCE_SECONDS, getBenAdminGreetingName, uiFlowBenAdmin} from "../utils/common";
import {CustomGrid, S3Image} from "./custom-common";
import IMAGE from "../constants/images";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    return {
        user,
        initialData: initialData,
        name: user.firstName,
        lang: user.lang,
        dependents: user.dependents,
        maritalStatus: user.maritalStatus,
        benAdmin: benAdmin,
        ...ownProps
    }
};

class ThanksWantToHearMore extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepProps: null
        };
    }

    componentDidMount() {
        const {initialData, user, benAdmin} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props);
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
    }

    render() {
        const localization = getLocalization(this.props.lang);
        const strings = localization.thanksWantToHearMore;
        const {uiFlow} = this.props.initialData;
        const isBenAdmin = uiFlow === uiFlowBenAdmin;
        const name = isBenAdmin ? getBenAdminGreetingName(this.props.benAdmin, this.props.initialData.distributionChannel) : this.props.name;
        return (
            <React.Fragment>
                <Container className={'wantToHearMoreContainer'}>
                    <CustomGrid container stackable columns={1}>
                        <CustomGrid.Row>
                            <CustomGrid.Column textAlign={'center'}>
                                <S3Image {...IMAGE.CHECK}/>
                                <Header as='h2'>{interpolateString(strings.title, [name])}</Header>
                                <p>{parseMultilineString(strings.subTitle)}</p>
                            </CustomGrid.Column>
                        </CustomGrid.Row>
                    </CustomGrid>
                </Container>
                <Footer
                    showTopFooter={true} showCenterData={true}
                    buttonText={localization.next}
                    onClickCallback={() => this.props.history.push(this.props.nextRoute)}
                    autoAdvanceSeconds={EDUCATIONAL_AUTO_ADVANCE_SECONDS}
                />
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(ThanksWantToHearMore));
